export function validateURL(textval) {
  // eslint-disable-next-line
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval)
}

export function checkImageURL(url) {
  if (typeof url === 'string' || url instanceof String) {
    return url.match(/\.(jpeg|jpg|gif|png)$/) != null
  }
  return false
}

export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

export function validateIdString(str) {
  if (!str) return true
  const reg = /^[1-9]\d*$/
  return reg.test(str)
}

export function validateNonNegativeInteger(str) {
  if (!str) return true
  const reg = /^(0|[1-9][0-9]*)$/
  return reg.test(str)
}

/**
 * Validate if IdsString is in format of '123123123,123123123,123123123'
 * @param str
 * @returns {boolean}
 */
export function validateIdsString(str) {
  if (!str) return true
  const reg = /^[0-9]+(,[0-9]+)*$/

  // ref ids string should be in format like '192,21,345,455'
  if (!reg.test(str)) {
    return false
  }

  // every ref ids are positive numbers
  return str.split(',').every(num => Number(num) > 0)
}

export function validateEmail(email) {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export function validateCountriesString(str) {
  if (!str) return true
  return str.split(',').every(country => country.length === 2)
}
